// extracted by mini-css-extract-plugin
module.exports = {"container":"_ba695d0","background":"_0ea0dbc","title":"_3aa3335","subTitle":"_cde1080"};